import { FC } from 'react'
import User from '../../../../../form-items/user/user'
import { NamePath } from 'antd/es/form/interface'

interface InitiatorProps {
    name?: NamePath
}

const Initiator: FC<InitiatorProps> = ({ name = 'initiator' }) => {
    return <User name={name} label={'Ответственный за поломку'} rules={[]} />
}

export default Initiator
